// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - OUTLINED INPUT (ERPNext style: soft grey field, white on focus) ||============================== //

export default function OutlinedInput(theme) {
  const v = theme.vars.palette;
  return {
    MuiOutlinedInput: {
      defaultProps: { notched: false },
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: '#F4F5F6',
          fontSize: '0.8125rem',
          transition: 'background-color .15s, box-shadow .15s',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent', top: 0, transition: 'border-color .15s' },
          '& .MuiOutlinedInput-notchedOutline legend': { display: 'none' },
          '&:hover': { backgroundColor: '#EEF0F2' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
          '&.Mui-focused': { backgroundColor: v.background.paper, boxShadow: `0 0 0 3px ${withAlpha(v.primary.main, 0.12)}` },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: v.primary.main, borderWidth: 1 },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: v.error.main },
          '&.Mui-error.Mui-focused': { boxShadow: `0 0 0 3px ${withAlpha(v.error.main, 0.12)}` },
          '&.Mui-disabled': { backgroundColor: v.grey[100], color: v.grey[500] }
        },
        input: { padding: '8px 10px', height: 'auto', '&::placeholder': { color: v.grey[500], opacity: 1 } },
        inputSizeSmall: { padding: '7px 10px' },
        inputMultiline: { padding: 0 },
        multiline: { padding: '8px 10px' },
        adornedStart: { paddingLeft: 10 },
        notchedOutline: { borderColor: 'transparent' }
      }
    },
    MuiInputAdornment: { styleOverrides: { root: { color: v.grey[500] } } },
    MuiSelect: { styleOverrides: { select: { minHeight: 'unset' } } },
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: { paddingTop: '3px !important', paddingBottom: '3px !important' }
      }
    }
  };
}
